(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-tabbed-content"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.product-tabbed-content .product-tabbed-heades__header').click(function(){
      var tab_id = $(this).attr('data-tab');
  
      $('.product-tabbed-heades__header').removeClass('current');
      $('.product-tabbed-tabs__tab').removeClass('current');
  
      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
    })
  })
  

  } catch(e) { console.error(e); }
})();
})();
